/**
 * @file Login Button.
 */

/**
 * Login Button Component.
 *
 * ! There should only be one per page.
 */
const vLoginButton = () => {
	const loginButton = document.querySelector('.v-login-button');

	if (!loginButton) {
		return;
	}

	const loginButtonWrap = document.querySelector('.v-login-button__form');
	const loginButtonForm = document.querySelector('.v-login-button__form form');

	const loginInfo = sessionStorage.getItem(`wb-${loginButtonForm.dataset.type}-login-info`);
	if (!loginInfo) {
		loginButton.parentElement.removeChild(loginButton);
		loginButtonWrap.classList.remove('v-login-form--hidden');
		return;
	}

	const loginArr = JSON.parse(loginInfo);

	loginButtonForm.querySelector('[name="_textBoxUserId"]').value    = loginArr.user_id;
	loginButtonForm.querySelector('[name="_textBoxCompanyId"]').value = loginArr.company_id;

	loginButton.addEventListener('click', () => {
		sessionStorage.removeItem(`wb-${loginButtonForm.dataset.type}-login-info`);
	});
};

export default vLoginButton;
